import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './FilterListItem';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';

import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import FilterStore from '../../stores/FilterStore';
import FilterActions from '../../actions/FilterActionCreator';

class FilterList extends Component {

    constructor (props) {
        super(props);
        this.state = {
            filters: [],
            count: 0,
            page: 0,
            limit: 50,
            searchPage: 0,
            searchMode: false,
            searchText: null,
            loading: false,
            fetchedAll: false,
            showButton: false
        };
        this.onChange = this.onChange.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.search = this.search.bind(this);
        this.toggleSearchMode = this.toggleSearchMode.bind(this);
    }

    componentDidMount() {
        FilterStore.addChangeListener(this.onChange);
        FilterActions.getAll({limit: this.state.limit});

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        FilterStore.removeChangeListener(this.onChange);

        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {

        const isAdmin      = this.context.auth.isAdmin();
        const newEntityUrl = isAdmin ? '/dashboard/filter/new' : '';

        return (
            <div ref="filterList">
                <ListView
                    title="Filters"
                    sortOptions={this.props.sortOptions}
                    sortAction={FilterActions.getAll}
                    searchAction={this.search}
                    items={this.state.filters}
                    itemDecorator={ListItem}
                    newEntityUrl={newEntityUrl}
                    toggleSearchMode={this.toggleSearchMode}
                />
                {this.state.loading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.loading}
                        fullWidth
                    />
                )}
            </div>
        );
    }

    onChange() {
        const filters = FilterStore.getAll();
        if (!!filters) {
            if (FilterStore.fetchedAll()) {
                this.setState({fetchedAll: true});
            }
            this.setState({ filters, loading: false });
        }
    }

    loadNextPage() {
        if (this.state.loading) { return; } //guard

        const page = !this.state.searchMode ? (this.state.page + 1) : (this.state.searchPage + 1);
        if (!this.state.searchMode) {
            FilterActions.getAll({page, limit: this.state.limit});
            this.setState({page, loading: true});
        } else if (!!this.state.searchText) {
            FilterActions.search(this.state.searchText, {page, limit: this.state.limit});
            this.setState({searchPage: page, loading: true});
        }
    }

    handleScroll() {
        if (!this.state.showButton && window.scrollY > 0) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.filterList.clientHeight) {
            this.loadNextPage();
        }
    }

    search(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { FilterActions.search(searchText, {limit: this.state.limit}); }, 500);

            if (searchText !== this.state.searchText) {
                this.setState({fetchedAll: false, showButton: false});
            }
            this.setState({searchText, searchPage: 0});
        }
    }

    toggleSearchMode(searchMode) {
        if (!searchMode) {
            this.setState({searchText: null});
        }
        this.setState({searchMode, fetchedAll: false, showButton: false});
    }
}

FilterList.contextTypes = {
        auth: PropTypes.object.isRequired
};

FilterList.defaultProps = {
    sortOptions: [
        {label: "Name", value: 'name'},
        {label: "Created", value: 'dateAdded'},
    ]
};

export default FilterList;
